import {Ng1Controller, Transition, TargetState, StateService} from "@uirouter/angularjs";
import {DataHubService} from "../../modules/DataHubModule";
import {CaseDto} from "../../model/CaseDto";
import {CaseFullDto} from "../../model/CaseFullDto";

export default class CreateCaseController implements Ng1Controller {
    private error: any;
    private model: CaseFullDto;

    $onInit(): void {
        this.refresh();
    }

    uiCanExit(transition: Transition): boolean | TargetState | void | Promise<boolean | TargetState | void> {
        return undefined;
    }

    uiOnParamsChanged(newValues: any, $transition$: Transition): void {
        console.debug('uiParamsChanged', newValues);
    }

    constructor(private $dataHub: DataHubService, private $state: StateService, private $stateParams: any) {
        $dataHub.onConnected(this.refresh)
    }

    refresh = () => {
        if (!this.$dataHub.isConnected) return;
        // load data or something
    }

    isAllowedCaseType(caseType) {
        if (this.model.company == null) return false;
        return this.model.company.caseTypes.length === 0 ||
            this.model.company.caseTypes.filter(c => c.guid === caseType.guid).length > 0;
    }

    setDefaults() {
        console.log('setDefaults');
        // if (!this.model.status)
        //     this.model.status = hub.caseStatus.list.filter(i => i.default)[0];
        // if (!this.model.priority)
        //     this.model.priority = hub.casePriority.list.filter(i => i.default)[0];
    }

    companyChanged(company) {
        console.debug('companyChanged', company);
        this.model.customer = null;
        this.customerChanged(null);
        // hub.customer.search('', company.customer.guid);
        // $location.search('companyGuid', company.guid);
    }

    customerChanged(customer) {
        this.model.location = null;
        this.model.contact = null;
        if (!customer) return;
        // $location.search('customerGuid', customer.guid);
    }

    locationChanged(location) {
        this.model.contact = null;
        if (!location) return;
        // hub.contact.load(this.model.customer, location);
        // $location.search('locationGuid', location.guid);
    }

    save() {
        // hub.case.save(this.model)
        //     .then(r => {
        //         console.log('dataHub.save', r);
        //         $window.location.href = `/Case/View?caseGuid=${r.guid}`;
        //     });
    }


    locationChangedX() {
        // console.log('locationChanged', $location.search());
        // if (!this.loaded || this.locationDone) return;
        // this.locationDone = true;
        // var companyGuid = $location.search().companyGuid,
        //     customerGuid = $location.search().customerGuid,
        //     locationGuid = $location.search().locationGuid,
        //     contactGuid = $location.search().contactGuid;
        //
        // if (!companyGuid) return;
        // this.model.company = hub.company.list.filter(l => l.guid === companyGuid)[0];
        // if (!this.model.company) return;
        //
        // if (!customerGuid) return;
        // await hub.customer.get(customerGuid);
        // this.model.customer = hub.customer.customers[customerGuid];
        // if (!this.model.customer) return;
        //
        // await hub.location.load(this.model.customer);
        // if (locationGuid) {
        //     this.model.location = hub.location.list.filter(l => l.guid === locationGuid)[0];
        //     await hub.contact.load(this.model.customer, this.model.location);
        // } else {
        //     await hub.contact.load(this.model.customer, null);
        // }
        //
        // if (contactGuid) {
        //     this.model.contact = hub.contact.list.filter(l => l.guid === contactGuid)[0];
        // }
    }
}

